import { Col, Divider, Input, Pagination, Row } from 'antd';
import { viewersApi } from 'api/viewUserApi';
import AddFormPlantOfViewer from 'components/Common/Modal/AddFormPlantOfViewer';
import { plantInfo } from 'models';
import { ViewerInfo } from 'models/viewers';
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import ItemPlantOfViewer from '../ItemPlantList/ItemPlantOfViewer';
import style from './ListOfPlant.module.scss';
export interface ListOfPlantProps {
  itemViewer: ViewerInfo;
}

export default function ListOfPlant({ itemViewer }: ListOfPlantProps) {
  const [pagePlant, setPagePlant] = React.useState<number>(0);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [plantList, setPlantList] = React.useState<plantInfo[]>([]);

  React.useEffect(() => {
    if (itemViewer) {
      (async () => {
        try {
          const res = await viewersApi.getPlantsByViewerId(itemViewer.id);
          setPlantList(res);
        } catch (error) {
          console.log('Failed to fetch student details', error);
        }
      })();
    }
  }, [itemViewer]);

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    console.log('🚀 ~ file: listOfGateWay.jsx ~ line 28 ~ onChangeValue ~ val', val);
  };

  const onChangePage = (page: number) => {
    setPagePlant(page - 1);
  };
  return (
    <>
      <Row className={style.root_list_plant}>
        <Row className={style.header_info}>
          <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
            List of Plant
          </Divider>
        </Row>
        <Row className={style.main}>
          <Row className={style.header_main}>
            <Input
              onChange={onChangeValue}
              size="large"
              placeholder="Search by label"
              prefix={<FaSearch />}
              className={style.search_header}
            />
            <FiPlus
              onClick={() => {
                setIsModalVisible(!isModalVisible);
              }}
              className={style.btn_create}
              style={{ cursor: 'pointer' }}
              size={20}
            />
          </Row>
          <div className={style.main_table}>
            <Row className={style.header_table}>
              <Col className={style.item_header} span={4}>
                CODE
              </Col>
              <Col className={style.item_header} span={8}>
                LABEL
              </Col>
              <Col className={style.item_header} span={5}>
                SYSTEM SIZE
              </Col>
              <Col span={7}>INSTALLED DATE</Col>
            </Row>
            <div className={style.content_table}>
              {plantList?.map((item, index) => {
                return (
                  index >= pagePlant * 10 &&
                  index < (pagePlant + 1) * 10 && (
                    <ItemPlantOfViewer
                      key={item.id}
                      setPlantList={setPlantList}
                      item={item}
                      itemViewer={itemViewer}
                    />
                  )
                );
              })}
            </div>
          </div>
        </Row>
        <Row className={style.footer_list}>
          <Pagination
            size="small"
            pageSize={10}
            // defaultCurrent={1}
            defaultCurrent={pagePlant + 1}
            total={plantList?.length}
            onChange={onChangePage}
            showSizeChanger={false}
            showQuickJumper={false}
          />
        </Row>
      </Row>

      <AddFormPlantOfViewer
        itemViewer={itemViewer}
        viewerPlant={plantList}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setPlantList={setPlantList}
      />
    </>
  );
}
